import { ComponentChildren, Fragment, toChildArray, VNode } from 'preact';

/**
 * Convert props.children value to flattened array. Will remove the Fragment if present
 */
export function preactToChildArray<P extends {} = {}>(
  children: ComponentChildren,
  predicate: (value: VNode<P>, index: number, array: Array<VNode<P>>) => boolean = () => true
): Array<VNode<P>> {
  return toChildArray(children)
    .reduce((acc, item: VNode<P>) => acc.concat(item.type === Fragment ? item.props.children : item), [])
    .filter(predicate);
}
